module.exports = __webpack_public_path__ + "img/10440c8.png";